export function TcsAgreement({ checked, onChange, testid = "tcs-agree", className = "" }) {
  return (
    <div className={`flex items-start gap-2 text-sm text-slate-700 ${className}`}>
      <input
        type="checkbox"
        data-testid={testid}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 accent-[#1E40AF]"
      />
      <span>
        I agree to SellStuff's{" "}
        <a href="/terms" target="_blank" rel="noopener noreferrer" data-testid={`${testid}-terms`} className="font-medium text-primary underline">Terms &amp; Conditions</a>,{" "}
        <a href="/refunds" target="_blank" rel="noopener noreferrer" data-testid={`${testid}-refunds`} className="font-medium text-primary underline">Refund Policy</a>{" "}and{" "}
        <a href="/delivery" target="_blank" rel="noopener noreferrer" data-testid={`${testid}-delivery`} className="font-medium text-primary underline">Delivery Policy</a>
      </span>
    </div>
  );
}
